module.exports = __webpack_public_path__ + "static/total_premium_orange.29e01ed4.svg";